import { render } from "./pr_request.vue?vue&type=template&id=653b09fd&scoped=true"
import script from "./pr_request.vue?vue&type=script&lang=js"
export * from "./pr_request.vue?vue&type=script&lang=js"

import "./pr_request.vue?vue&type=style&index=0&id=653b09fd&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653b09fd"]])

export default __exports__